// extracted by mini-css-extract-plugin
export default {"star":"StarRatings_star__beu7q","tooltip":"StarRatings_tooltip__ezS1B","defaultRating":"StarRatings_defaultRating__ZK1hI"};